import styled from 'styled-components';
import { InputGradient } from '../../components/Buttons';
import { FontFamilyRegular, FontSize14, FontSize18 } from '../../components/fonts';
import { MarginTop20, MarginBottom20 } from '../../components/margins';
import { size } from '../../components/media-queries';

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
`

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    ${MarginBottom20};
`

export const SectionTitle = styled.h3`
    color: #3f5063;
    font-size: 16px;
    font-weight: 500;
    margin-top: 0;
    ${MarginBottom20}
    text-transform: uppercase;
`
export const SectionText = styled.p`
    color: #3f5063;
    font-size: 14px;
    font-weight: 500;
    margin-top: 0;
    ${MarginBottom20}
    
`
export const RadioButtonContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    ${FontFamilyRegular}
    ${FontSize14}
    ${MarginBottom20}
    margin-bottom: 60px;
`;

export const AccordionContainer = styled.div`
    margin-top: 60px;
    width: 100%;
`;

export const FormTitle = styled.p`
    ${FontSize18}
    ${MarginTop20}
    ${MarginBottom20}
    text-align: left;
    display: ${props => props.isHidden ? 'none' : 'block'};
`

export const RadioSquare = styled.div`
  width: 24px;
  height: 24px;
  border: solid 2px #3f5063;
`;

export const InputBooleanContainer = styled.div`
    margin-bottom: ${props => props.hasNoMargin ? '8px': '60px'};
    width: 100%;
`;